import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import LogoAtivaJa from "@/components/LogoAtivaJa";
import { Button } from "@/components/ui/button";
import { Clock, XCircle, LogOut } from "lucide-react";
import DocumentosMontador from "@/components/DocumentosMontador";

export default function CadastroEmAnalise() {
  const { user, logout } = useAuth();
  const recusado = user?.aprovacao_status === "recusada";
  const isMontador = user?.role === "montador";

  return (
    <div className="min-h-screen bg-aj-surface flex items-center justify-center p-6 font-body"
      data-testid="cadastro-em-analise">
      <div className={`aj-card-elevated w-full p-8 sm:p-10 text-center ${isMontador && !recusado ? "max-w-2xl" : "max-w-lg"}`}>
        <div className="flex justify-center mb-6"><LogoAtivaJa size="lg" slogan /></div>
        {recusado ? (
          <>
            <XCircle className="w-12 h-12 mx-auto text-[#E60000] mb-4" />
            <h1 className="font-display font-extrabold text-2xl text-aj-blue-deep">Cadastro não aprovado</h1>
            <p className="text-sm text-aj-text-muted mt-3">
              Seu cadastro não foi aprovado pelo administrador neste momento.
              {user?.aprovacao_motivo && (
                <span className="block mt-2 font-semibold text-aj-text">Motivo: "{user.aprovacao_motivo}"</span>
              )}
            </p>
            <p className="text-sm text-aj-text-muted mt-2">Em caso de dúvidas, fale com a central MontaJá.</p>
          </>
        ) : (
          <>
            <Clock className="w-12 h-12 mx-auto text-aj-orange mb-4" />
            <h1 className="font-display font-extrabold text-2xl text-aj-blue-deep">Cadastro em análise</h1>
            <p className="text-sm text-aj-text-muted mt-3">
              Recebemos seu cadastro! Nossa equipe está validando as informações.
              Assim que o administrador liberar, você será avisado pelo <b>WhatsApp</b> e poderá operar normalmente.
            </p>
            <div className="mt-4 text-xs font-bold uppercase tracking-wider text-aj-orange bg-aj-amber-soft rounded-lg py-2 px-3 inline-block">
              Aguardando liberação do administrador
            </div>
            {isMontador && (
              <div className="mt-6 border-t border-border pt-6">
                <DocumentosMontador />
              </div>
            )}
          </>
        )}
        <div className="mt-8">
          <Button variant="outline" onClick={logout} data-testid="analise-sair">
            <LogOut size={15} /> Sair
          </Button>
        </div>
      </div>
    </div>
  );
}
